export default "__VITE_ASSET__Bz9SOd27__"